import { SvgIcon, SvgIconProps } from '@mui/material';

export function AddSmallIcon(props: SvgIconProps) {
  const defaultColor = '#FFFFFF';
  return (
    <SvgIcon
      {...props}
      viewBox='0 0 14 14'
      fill='none'
    >
      <path
        id='Vector'
        d='M11.0833 6.41732H7.58325V2.91732C7.58325 2.76261 7.52179 2.61424 7.4124 2.50484C7.303 2.39544 7.15463 2.33398 6.99992 2.33398C6.84521 2.33398 6.69684 2.39544 6.58744 2.50484C6.47804 2.61424 6.41659 2.76261 6.41659 2.91732V6.41732H2.91659C2.76188 6.41732 2.6135 6.47878 2.50411 6.58817C2.39471 6.69757 2.33325 6.84594 2.33325 7.00065C2.33325 7.15536 2.39471 7.30373 2.50411 7.41313C2.6135 7.52253 2.76188 7.58398 2.91659 7.58398H6.41659V11.084C6.41659 11.2387 6.47804 11.3871 6.58744 11.4965C6.69684 11.6059 6.84521 11.6673 6.99992 11.6673C7.15463 11.6673 7.303 11.6059 7.4124 11.4965C7.52179 11.3871 7.58325 11.2387 7.58325 11.084V7.58398H11.0833C11.238 7.58398 11.3863 7.52253 11.4957 7.41313C11.6051 7.30373 11.6666 7.15536 11.6666 7.00065C11.6666 6.84594 11.6051 6.69757 11.4957 6.58817C11.3863 6.47878 11.238 6.41732 11.0833 6.41732Z'
        fill={props.color ?? defaultColor}
      />
    </SvgIcon>
  );
}
